import { type GetCountryValue } from "../../common/components/CountrySelectionDropDown";
import { PaymentMethod } from "../../common/types/enums";
import { type PaymentMethodEnum as PaymentMethodEnumType } from "../../graphql/supergraph.index";
import { PaymentMethodEnum } from "../../graphql/supergraphOperations";
import { type PaymentMethodValue } from "./Context/types";

export const getCountryValue: GetCountryValue = ({ id, name }) => `${name}:${id}`;

export const mapCountryToValueSafely = (id?: string, name?: string): string =>
  id && name ? `${name}:${id}` : "";

export const getNameFromCountry = (country?: string | null) =>
  country?.substring(0, country.indexOf(":"))?.trim() ?? "";

export const getIdFromCountry = (country?: string) =>
  country?.substring(country.indexOf(":") + 1)?.trim() ?? "";

export const getAvailablePaymentMethods: (input: {
  availablePaymentMethods: PaymentMethodEnumType[];
}) => Record<PaymentMethod, PaymentMethodValue> = ({
  availablePaymentMethods,
}: {
  availablePaymentMethods: PaymentMethodEnumType[];
}) => {
  return {
    [PaymentMethod.ACH]: {
      isAvailable: availablePaymentMethods.includes(PaymentMethodEnum.Ach),
      warning: "",
    },
    [PaymentMethod.Wire]: {
      isAvailable: availablePaymentMethods.includes(PaymentMethodEnum.Wire),
      warning: "",
    },
    [PaymentMethod.Check]: {
      isAvailable: availablePaymentMethods.includes(PaymentMethodEnum.Check),
      warning: "",
    },
  };
};

/**
 * Gets the single available payment method if exactly one is available.
 *
 * @param paymentMethods - Record of payment methods with their availability status
 * @returns The PaymentMethod if exactly one is available, undefined otherwise
 */
export const getSingleAvailablePaymentMethod = (
  paymentMethods: Record<PaymentMethod, PaymentMethodValue>,
): PaymentMethod | undefined => {
  let availableMethod: PaymentMethod | undefined = undefined;
  let count = 0;

  for (const method of Object.values(PaymentMethod)) {
    if (paymentMethods[method]?.isAvailable === true) {
      availableMethod = method;
      count++;
      if (count > 1) {
        break; // Early exit if more than one method is available
      }
    }
  }

  if (count === 1 && availableMethod) {
    return availableMethod;
  }

  return undefined;
};
